import React from 'react';
import { useSelector } from 'react-redux';
import NotificationsIcon from '@material-ui/icons/Notifications';

import styles from './NotificationIcon.module.css';


const NotificationIcon = () => {

  const notificationCount = useSelector(({ notifications }) => {
    return notifications.notifications.filter(item => item.status === "New" && item.notifyInApp).length;
  });

  return (
    <div
      className={styles.notificationsIconContainer}
      style={notificationCount > 0 ? {marginRight: '4px'} : {}}
    >
      <NotificationsIcon className={styles.notificationsIcon} />
      {notificationCount > 0 && (
        <div className={styles.badge}>{notificationCount}</div>
      )}
    </div>
  );

};

export default NotificationIcon;